module.exports = __webpack_public_path__ + "img/246b2da1e8b34a689e3c2d7c4b15d39b.f15aebc2.png";